import React, { Component } from 'react';
import { connect } from 'shalala';
import { Button } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import { useStore } from '../../../../store';
import ComprobanteStatus from '../../support/enum/ComprobanteStatus';
import ComprobanteCancellationModal from './ComprobanteCancellationModal';

class SingleComprobanteCancelAction extends Component {
  state = {
    open: false,
  };

  handleCancellationClick = () => {
    this.setState({
      open: true,
    });
  };

  handleOnClose = (success) => {
    if (success) {
      const { data } = this.props.cancel;

      if (!!data && !!data.id) {
        this.props.infoActions.setPartialState({
          ...data,
          ...data.comprobante,
        });

        const newList = this.props.list.data.map((item) => {
          if (item.id === data.comprobante.id) {
            item = { ...data.comprobante };
          }

          return item;
        });

        this.props.listActions.setPartialState({ data: newList });
      }
    }

    this.setState({
      open: false,
    });
  };

  render() {
    const { open } = this.state;
    const { data } = this.props;

    const status = ComprobanteStatus.search(data.status) || ComprobanteStatus.undefined();

    return (
      <>
        {!!data.sat_url && Guardian.allows('factura.validar') && (
          <a
            target="_blank"
            href={data.sat_url}
            rel="noopener noreferrer"
            className="btn btn-secondary text-muted mr-2"
          >
            Validar
          </a>
        )}

        {!status.isCancelled() && Guardian.allows('factura.cancelar') && (
          <Button
            variant="secondary"
            className="text-muted mr-2"
            onClick={this.handleCancellationClick}
          >
            Cancelar
          </Button>
        )}

        {!!open && (
          <ComprobanteCancellationModal
            data={data}
            cancel={this.props.cancelActions.cancel}
            comprobante={this.props.cancel}
            onClose={this.handleOnClose}
          />
        )}
      </>
    );
  }
}

const mapState = (store) => {
  return {
    list: store.app.comprobantes.list,
    info: store.app.comprobantes.info,
    cancel: store.app.comprobantes.cancel,
  };
};

const mapActions = (actions) => {
  return {
    listActions: actions.app.comprobantes.list,
    infoActions: actions.app.comprobantes.info,
    cancelActions: actions.app.comprobantes.cancel,
  };
};

export default connect(useStore, mapState, mapActions)(SingleComprobanteCancelAction);
